export const toggleMenu = () => {
  document.body.classList.toggle('is-menu-open');
};
